import { createSlice } from '@reduxjs/toolkit'
import { printApiError } from '../../helpers/Util'
import { toast } from 'react-toastify'

const initialState = {
    isOpen: false,
    id: null,
    type: 'PRODUCT_DEVELOPMENT_COMMENT',
    pageId: null,
    conversationsType: null,
    styleList: [],
    onCloseCallback: null
}

const conversationViewSlice = createSlice({
    name: 'conversationView',
    initialState,
    reducers: {
        openConversationView: (state, action) => {
            state.isOpen = true
            state.id = action.payload.id
            state.type = action.payload.type || 'PRODUCT_DEVELOPMENT_COMMENT'
            state.pageId = action.payload.pageId
            state.conversationsType = action.payload.conversationsType
            state.styleList = action.payload.styleList || []
            state.onCloseCallback = action.payload.onCloseCallback
        },
        closeConversationView: (state) => {
            if (state.onCloseCallback) {
                const callback = state.onCloseCallback

                Object.assign(state, initialState)

                try {
                    callback()
                } catch (e) {
                    toast.error(e.message)
                }
            } else {
                Object.assign(state, initialState)
            }
        }
    }
})

export const { openConversationView, closeConversationView } =
    conversationViewSlice.actions

export const useConversationView = (state) => state.conversationView

export default conversationViewSlice.reducer
